import React from 'react';
import { useTranslation } from 'react-i18next';

import { Form, Input, TextArea, InputLabel, TranslateDropdown } from '@weezevent/nacre';

import css from './components.module.css';

export const TranslatableInput = ({ field, item, label_prefix, label, placeholder_prefix, placeholder, inputType = 'input', defaultLanguage, languageOptions, handleChange }) => {
    const { t } = useTranslation();
    const [selectedLanguage, setSelectedLanguage] = React.useState(defaultLanguage);

    const Component = React.useMemo(() => (inputType === 'input' ? Input : TextArea), [inputType]);

    return (
        <Form.Field>
            <div className={css['translatable-field']}>
                <InputLabel label={label_prefix ? t(`${label_prefix}.${field}`) : label} />
                {!!Object.keys(item.translations[field]).length && (
                    <TranslateDropdown
                        languages={languageOptions}
                        defaultValue={defaultLanguage}
                        onChange={value => setSelectedLanguage(value)}
                        selected={Object.keys(item.translations[field] || {})}
                    />
                )}
            </div>
            <Component
                value={!Object.keys(item.translations[field])?.length || selectedLanguage === defaultLanguage ? item[field] : item.translations[field][selectedLanguage] || ''}
                onChange={({ target: { value } }) => handleChange(field, value, selectedLanguage)}
                placeholder={placeholder_prefix ? t(`${label_prefix}.${field}`) : placeholder}
            />
        </Form.Field>
    );
};
